var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitilliumWebV8Latin700(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "TitilliumWeb",
    horizAdvX: 506
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Titillium Web",
    unitsPerEm: 1000,
    panose1: "0 0 8 0 0 0 0 0 0 0",
    ascent: 1133,
    descent: -388,
    alphabetic: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    glyphName: "space",
    horizAdvX: 220
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    glyphName: "exclam",
    horizAdvX: 280,
    d: "M68 0V161H212V0H68ZM81 250L68 680H213L199 250H81Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    glyphName: "quotedbl",
    horizAdvX: 411,
    d: "M350 440H232L228 680H357L350 440ZM178 440H60L55 680H184L178 440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    glyphName: "numbersign",
    horizAdvX: 560,
    d: "M544 149H448V0H332V149H228V0H112V149H16V261H112V387H16V499H112V660H228V499H332V660H448V499H544V387H448V261H544V149ZM332 261V387H228V261H332Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    glyphName: "dollar",
    horizAdvX: 560,
    d: "M508 199Q508 95 445 42T280 -12H279L264 -130Q190 -127 190 -123L204 -7Q130 2 80 14L60 18L73 122Q152 111 219 107L241 281Q138 312 95 356T52 476Q52 575 112 623T277 672H290L308 810H382L364 666Q426 660 478 650L495 646L484 540Q411 548 349 552L329 391Q433 358 470 319T508 199ZM185 485Q185 461 200 446T258 415L275 554Q185 550 185 485ZM375 190Q375 214 362 229T313 259L294 106Q375 115 375 190Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    glyphName: "percent",
    horizAdvX: 560,
    d: "M125 -8L360 699L433 673L198 -32L125 -8ZM14 672T134 672T254 527T134 381T14 526ZM112 563T112 527T116 476T134 461T151 476T156 527T152 577T134 592T117 578ZM306 279T426 279T546 134T426 -12T306 133ZM404 170T404 134T408 83T426 68T443 83T448 134T444 184T426 199T409 185Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    glyphName: "ampersand",
    horizAdvX: 701,
    d: "M111 631T167 671T318 712T467 671T520 557T490 444T383 349L481 251Q487 266 493 309T500 379L630 376Q615 260 579 173L691 75L615 -12L509 75Q474 37 420 13T304 -12Q158 -12 97 40T35 196Q35 277 69 323T177 399Q136 449 124 480T111 561Q111 631 167 671ZM287 108Q327 108 365 119T418 148L245 321Q171 285 171 207Q171 108 287 108ZM247 531Q247 491 292 443L309 425Q350 455 367 478T384 535Q384 598 316 598T247 531Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    glyphName: "quotesingle",
    horizAdvX: 239,
    d: "M60 440L56 680H185L178 440H60Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    glyphName: "parenleft",
    horizAdvX: 308,
    d: "M186 389T186 301T210 107T258 -62L281 -125H154Q140 -103 117 -51T79 48T51 164T38 301T50 439T79 563Q115 675 142 727L154 750H281Q247 663 217 526Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    glyphName: "parenright",
    horizAdvX: 308,
    d: "M270 368T270 301T258 166T229 47Q193 -58 166 -104L154 -125H27Q61 -48 91 82T122 301T99 501T51 682L27 750H154Q168 725 191 669T229 562T257 440Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    glyphName: "asterisk",
    horizAdvX: 425,
    d: "M389 499H266L304 379L231 357L190 478L87 399L40 458L145 536L43 609L89 672L190 599L229 720L304 695L266 573H389V499Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    glyphName: "plus",
    horizAdvX: 560,
    d: "M50 191V311H219V479H339V311H510V191H339V21H219V191H50Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    glyphName: "comma",
    horizAdvX: 263,
    d: "M20 -123L70 137H218L128 -123H20Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    glyphName: "hyphen",
    horizAdvX: 408,
    d: "M56 205V327H352V205H56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    glyphName: "period",
    horizAdvX: 256,
    d: "M56 0V166H200V0H56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    glyphName: "slash",
    horizAdvX: 466,
    d: "M31 8L319 718L437 676L149 -34L31 8Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    glyphName: "zero",
    horizAdvX: 560,
    d: "M153 672T280 672T471 590T536 327T472 67T280 -12T88 66T24 326T88 590ZM394 453T368 502T281 552T193 502T166 329T193 157T281 108T368 157T394 329Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    glyphName: "one",
    horizAdvX: 560,
    d: "M418 660V0H280V504L137 412L74 515L292 660H418Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    glyphName: "two",
    horizAdvX: 560,
    d: "M493 0H65V117L206 260Q281 337 310 378T340 465T316 531T246 550Q179 550 100 538L76 535L69 642Q167 672 272 672Q482 672 482 483Q482 409 450 355T334 224L219 120H493V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    glyphName: "three",
    horizAdvX: 560,
    d: "M62 636Q154 672 267 672T433 629T485 489T408 342Q456 316 476 288T497 199Q497 92 444 40T272 -12Q185 -12 89 14L57 22L64 127Q176 108 252 108Q355 108 355 196Q355 233 329 255T259 277H126V391H259Q292 391 317 419T343 481Q343 552 244 552Q175 552 97 538L71 534L62 636Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    glyphName: "four",
    horizAdvX: 560,
    d: "M320 0V109H40V214L203 660H355L178 229H320V414H458V229H521V109H458V0H320Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    glyphName: "five",
    horizAdvX: 560,
    d: "M490 660V540H195L178 397Q240 421 296 421Q510 421 510 222Q510 110 451 49T284 -12Q238 -12 180 -3T86 16L50 25L65 127Q186 108 267 108Q316 108 342 134T368 208T346 279T284 301Q217 301 166 288L151 284L69 303L87 660H490Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    glyphName: "six",
    horizAdvX: 560,
    d: "M496 537Q394 552 319 552Q177 552 177 398L198 404Q264 423 303 423Q416 423 473 371T530 210T466 44T281 -12T97 76T35 337T106 590T310 672Q388 672 477 650L508 643L496 537ZM291 303Q244 303 193 286L176 281Q176 108 288 108Q336 108 362 134T388 209Q388 303 291 303Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    glyphName: "seven",
    horizAdvX: 560,
    d: "M69 537V660H491V504L256 -12L128 24L353 505V537H69Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    glyphName: "eight",
    horizAdvX: 560,
    d: "M169 672T278 672T454 624T521 491Q521 433 507 404T449 340Q493 303 512 270T531 179Q531 81 461 35T278 -12Q28 -12 28 168Q28 232 47 267T111 340Q69 374 54 406T39 492Q39 577 104 624ZM176 200Q176 112 279 112T383 200Q383 252 324 275H236Q176 252 176 200ZM280 548Q235 548 211 528T187 467T236 392H324Q373 426 373 470Q373 548 280 548Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    glyphName: "nine",
    horizAdvX: 560,
    d: "M248 108Q381 108 381 270L360 263Q291 240 255 240Q146 240 87 293T28 450T93 613T277 672T460 584T523 321T453 67T248 -12Q170 -12 81 10L50 17L62 123Q164 108 248 108ZM267 360Q313 360 366 378L382 383Q382 552 270 552Q222 552 196 526T170 451Q170 360 267 360Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    glyphName: "colon",
    horizAdvX: 256,
    d: "M56 289V455H200V289H56ZM56 0V166H200V0H56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    glyphName: "semicolon",
    horizAdvX: 279,
    d: "M77 137H225L135 -123H27L77 137ZM69 289V455H213V289H69Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    glyphName: "less",
    horizAdvX: 560,
    d: "M472 353L211 254L472 146V10L66 196V306L472 489V353Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    glyphName: "equal",
    horizAdvX: 560,
    d: "M58 295V416H502V295H58ZM58 87V208H502V87H58Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    glyphName: "greater",
    horizAdvX: 560,
    d: "M349 254L88 353V489L494 306V196L88 10V146L349 254Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    glyphName: "question",
    horizAdvX: 437,
    d: "M308 692T356 653T405 536T390 423T324 350T261 292T248 248V217H141Q110 251 110 308Q110 344 173 395T251 465T266 513Q266 572 181 572Q121 572 58 560L37 556L30 657Q116 692 212 692ZM119 0V161H263V0H119Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    glyphName: "at",
    horizAdvX: 973,
    d: "M944 305V297Q944 143 896 72T751 0Q680 0 635 36Q625 44 618 56Q538 0 470 0Q376 0 330 58T283 247T326 439T474 500Q509 500 550 482L565 475V488H699V309Q699 171 704 151T716 123T730 114T749 112Q781 112 795 151T810 297V306Q810 466 737 538T503 611T257 519T172 252T248 -7T503 -91L646 -82L651 -199Q561 -209 503 -209Q388 -209 305 -186T160 -110Q38 -3 38 261Q38 492 163 610T505 729T833 621T944 305ZM481 118Q519 118 571 143Q565 179 565 249V372Q523 382 504 382Q452 382 436 353T419 251Q419 118 481 118Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    glyphName: "A",
    horizAdvX: 602,
    d: "M17 0L170 680H432L585 0H447L420 123H182L155 0H17ZM277 566L208 243H394L325 566H277Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    glyphName: "B",
    horizAdvX: 609,
    d: "M74 680H341Q447 680 500 638T553 500Q553 443 536 410T478 350Q523 331 544 295T566 195Q566 96 508 48T345 0H74V680ZM338 284H212V118H338Q383 118 404 136T426 202Q426 284 338 284ZM334 562H212V400H335Q413 400 413 481T334 562Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    glyphName: "C",
    horizAdvX: 543,
    d: "M505 11Q399 -12 314 -12T178 9T98 76T58 184T47 340Q47 537 102 614T307 692Q393 692 506 665L502 555Q403 570 338 570T244 553T203 486T189 319T216 156T326 110T502 124L505 11Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    glyphName: "D",
    horizAdvX: 638,
    d: "M303 0H74V680H303Q391 680 448 662T536 601T580 501T592 351T581 199T540 91T451 22T303 0ZM448 270Q450 302 450 358T446 449T427 511T383 549T303 560H212V120H303Q378 120 412 158Q441 189 448 270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    glyphName: "E",
    horizAdvX: 554,
    d: "M74 0V680H514V560H212V401H454V283H212V120H514V0H74Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    glyphName: "F",
    horizAdvX: 531,
    d: "M74 0V680H508V560H212V360H454V240H212V0H74Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    glyphName: "G",
    horizAdvX: 611,
    d: "M357 244V364H555V11Q412 -12 323 -12Q164 -12 105 73T45 343T107 610T318 692Q411 692 519 671L555 664L551 557Q431 570 355 570T247 552T202 486T187 320T216 155T336 108L419 112V244H357Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    glyphName: "H",
    horizAdvX: 677,
    d: "M465 0V282H212V0H74V680H212V402H465V680H603V0H465Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    glyphName: "I",
    horizAdvX: 286,
    d: "M74 0V680H212V0H74Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    glyphName: "J",
    horizAdvX: 302,
    d: "M19 -70V50Q59 50 77 65T95 121V680H232L233 115Q233 6 185 -32T19 -70Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    glyphName: "K",
    horizAdvX: 593,
    d: "M212 0H74V680H212V381L304 391L416 680H573L425 339L577 0H418L304 271L212 261V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    glyphName: "L",
    horizAdvX: 472,
    d: "M461 0H74V680H212V122H461V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    glyphName: "M",
    horizAdvX: 858,
    d: "M74 0V680H309L429 184L549 680H784V0H646V526H631L498 30H360L227 526H212V0H74Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    glyphName: "N",
    horizAdvX: 693,
    d: "M74 0V680H307L471 120H481V680H619V0H392L222 560H212V0H74Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    glyphName: "O",
    horizAdvX: 652,
    d: "M245 108T326 108T436 160T466 336T436 516T326 572T216 516T186 337T215 161ZM481 -12T326 -12T108 72T44 337T107 604T326 692T544 605T608 337T545 73Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    glyphName: "P",
    horizAdvX: 589,
    d: "M324 198H212V0H74V680H324Q566 680 566 444Q566 325 505 262T324 198ZM212 316H323Q426 316 426 444Q426 507 401 534T323 562H212V316Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    glyphName: "Q",
    horizAdvX: 652,
    d: "M326 -12Q170 -12 107 72T44 336T107 604T326 692T544 605T608 336Q608 114 503 37L586 -97L460 -156L370 -9Q360 -12 326 -12ZM245 108T326 108T436 160T466 336T436 516T326 572T216 516T186 336T215 160Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    glyphName: "R",
    horizAdvX: 620,
    d: "M212 228V0H74V680H338Q578 680 578 456Q578 323 478 260L575 0H424L345 228H212ZM389 346T413 376T437 455T412 533T338 562H212V346H340Q389 346 413 376Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    glyphName: "S",
    horizAdvX: 544,
    d: "M283 572Q174 572 174 500Q174 468 201 451T327 402T467 330T507 205Q507 98 442 43T272 -12Q194 -12 81 12L45 19L59 126Q193 108 264 108Q370 108 370 196Q370 228 346 246T248 285Q132 318 85 363T37 490Q37 592 99 642T269 692Q343 692 457 672L493 665L482 556Q341 572 283 572Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    glyphName: "T",
    horizAdvX: 526,
    d: "M13 558V680H513V558H333V0H195V558H13Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    glyphName: "U",
    horizAdvX: 654,
    d: "M206 227Q206 108 327 108T448 227V680H586V230Q586 105 522 47T327 -12T133 46T68 230V680H206V227Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    glyphName: "V",
    horizAdvX: 603,
    d: "M442 680H587L429 0H174L16 680H161L279 120H324L442 680Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    glyphName: "W",
    horizAdvX: 930,
    d: "M19 680H164L248 118H263L385 680H545L667 118H682L766 680H911L781 0H572L465 517L358 0H149L19 680Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    glyphName: "X",
    horizAdvX: 569,
    d: "M162 680L288 430L417 680H560L364 333L560 0H407L281 235L152 0H9L205 326L9 680H162Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    glyphName: "Y",
    horizAdvX: 557,
    d: "M348 0H210V275L0 680H153L278 409L403 680H556L348 275V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    glyphName: "Z",
    horizAdvX: 532,
    d: "M41 560V680H491V560L207 138V120H491V0H41V119L325 542V560H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    glyphName: "bracketleft",
    horizAdvX: 355,
    d: "M320 749V629H205V-3H320V-123H68V749H320Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    glyphName: "backslash",
    horizAdvX: 498,
    d: "M466 13L350 -36L32 664L146 716L466 13Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    glyphName: "bracketright",
    horizAdvX: 355,
    d: "M35 629V749H287V-123H35V-3H150V629H35Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    glyphName: "asciicircum",
    horizAdvX: 560,
    d: "M383 313L274 530L161 313H21L215 660H329L523 313H383Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    glyphName: "underscore",
    horizAdvX: 620,
    d: "M96 -73H524V-187H96V-73Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    glyphName: "grave",
    horizAdvX: 268,
    d: "M23 753L275 651L245 564L-17 638L23 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    glyphName: "a",
    horizAdvX: 511,
    d: "M445 344V136Q447 112 453 103T478 89L474 -12Q423 -12 393 -5T331 23Q259 -12 184 -12Q29 -12 29 152Q29 232 72 265T204 305L311 313V344Q311 375 297 386T252 398L64 390L60 483Q167 512 263 512T402 472T445 344ZM220 212Q164 207 164 152T213 97Q251 97 296 109L311 113V220L220 212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    glyphName: "b",
    horizAdvX: 544,
    d: "M304 512Q409 512 457 455T506 249T450 45T257 -12Q214 -12 100 -2L62 2V700H196V485Q260 512 304 512ZM257 108Q324 108 347 140T370 257Q370 392 286 392Q246 392 210 382L196 379V112Q242 108 257 108Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    glyphName: "c",
    horizAdvX: 446,
    d: "M249 512Q301 512 382 496L409 490L405 384Q326 392 288 392Q219 392 197 363T174 251T196 139T289 108L405 116L409 9Q302 -12 246 -12Q135 -12 87 50T38 251T88 450T249 512Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    glyphName: "d",
    horizAdvX: 549,
    d: "M487 700V0H354V21Q284 -12 233 -12Q124 -12 81 51T38 250T89 449T245 512Q277 512 334 502L353 498V700H487ZM339 120L353 123V386Q298 396 255 396Q174 396 174 252Q174 174 192 141T251 108T339 120Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    glyphName: "e",
    horizAdvX: 510,
    d: "M173 147T196 127T264 106Q357 106 430 112L458 115L460 16Q345 -12 252 -12Q139 -12 88 48T37 243Q37 512 258 512Q476 512 476 286L466 193H172Q173 147 196 127ZM344 295Q344 355 325 378T259 402T192 378T171 295H344Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    glyphName: "f",
    horizAdvX: 357,
    d: "M220 386V0H86V386H32V500H86V522Q86 630 118 671T232 712Q268 712 325 702L346 699L344 590Q300 592 270 592T230 576T220 521V500H341V386H220Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    glyphName: "g",
    horizAdvX: 534,
    d: "M515 -148T449 -189T271 -230T98 -200T37 -91Q37 -28 109 28Q72 53 72 104Q72 124 102 170L111 184Q43 233 43 328T100 467T253 510Q296 510 338 500L354 497L515 502V395L440 401Q462 367 462 333Q462 233 411 195T251 157Q228 157 210 161Q200 135 200 119T217 96T297 89Q423 88 469 56T515 -62ZM169 -77Q169 -120 274 -120T380 -70Q380 -43 362 -36T286 -27L196 -20Q169 -47 169 -77ZM177 259T253 259T330 332T254 406T177 333Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    glyphName: "h",
    horizAdvX: 553,
    d: "M196 0H62V700H196V476Q265 512 320 512Q420 512 458 453T496 271V0H362V268Q362 331 347 361T287 392Q248 392 209 380L196 376V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    glyphName: "i",
    horizAdvX: 258,
    d: "M62 0V500H196V0H62ZM62 564V700H196V564H62Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    glyphName: "j",
    horizAdvX: 259,
    d: "M63 24V500H197V23Q197 -79 162 -127T19 -230L-34 -131Q11 -101 29 -84T55 -44T63 24ZM63 564V700H197V564H63Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    glyphName: "k",
    horizAdvX: 515,
    d: "M196 0H62V700H196V302L247 311L346 500H496L366 263L503 0H352L251 195L196 186V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    glyphName: "l",
    horizAdvX: 270,
    d: "M68 0V700H202V0H68Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    glyphName: "m",
    horizAdvX: 839,
    d: "M196 0H62V500H195V472Q264 512 313 512Q394 512 438 465Q530 512 606 512Q705 512 743 455T782 271V0H648V267Q648 331 634 361T578 392Q546 392 500 378L485 373Q489 298 489 259V0H355V257Q355 331 342 361T285 392Q246 392 208 378L196 374V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    glyphName: "n",
    horizAdvX: 553,
    d: "M196 0H62V500H195V472Q263 512 320 512Q420 512 458 453T496 271V0H362V267Q362 331 347 361T287 392Q246 392 208 378L196 374V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    glyphName: "o",
    horizAdvX: 532,
    d: "M142 512T266 512T443 444T496 251Q496 -12 266 -12T36 251Q36 375 89 443ZM213 102T266 102T339 138T360 251T340 363T266 398T193 363T172 251T192 138Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    glyphName: "p",
    horizAdvX: 544,
    d: "M62 -210V500H195V473Q260 512 309 512Q410 512 458 452T506 246T453 45T279 -12Q246 -12 208 -6L196 -4V-210H62ZM283 392Q246 392 208 377L196 372V110Q241 104 269 104Q327 104 348 138T370 254Q370 392 283 392Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    glyphName: "q",
    horizAdvX: 543,
    d: "M239 -12Q134 -12 86 45T38 251T93 456T286 512Q347 512 445 502L481 499V-210H347V15Q283 -12 239 -12ZM286 396Q219 396 196 362T172 243Q172 108 257 108Q297 108 334 118L347 121V392Q310 396 286 396Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    glyphName: "r",
    horizAdvX: 372,
    d: "M62 0V500H195V447Q279 497 355 512V377Q274 360 216 342L196 335V0H62Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    glyphName: "s",
    horizAdvX: 472,
    d: "M421 375Q297 391 248 391T184 382T169 354T188 327T288 305T403 257T437 150Q437 -12 236 -12Q170 -12 76 6L44 12L48 124Q172 108 220 108T286 117T304 146T286 174T190 196T74 240T36 350T90 470T229 511Q288 511 390 492L423 486L421 375Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    glyphName: "t",
    horizAdvX: 364,
    d: "M339 386H216V181Q216 151 217 139T228 117T258 108L334 110L340 3Q273 -12 238 -12Q148 -12 115 28T82 178V386H23V500H82V639H216V500H339V386Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    glyphName: "u",
    horizAdvX: 553,
    d: "M357 500H491V0H358V28Q286 -12 233 -12Q129 -12 93 45T57 238V500H191V236Q191 162 203 135T261 108Q305 108 344 122L357 126V500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    glyphName: "v",
    horizAdvX: 498,
    d: "M15 500H155L235 114H263L347 500H483L363 0H135L15 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    glyphName: "w",
    horizAdvX: 772,
    d: "M24 500H156L217 114H241L317 490H455L531 114H555L616 500H748L653 0H443L386 306L329 0H119L24 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    glyphName: "x",
    horizAdvX: 474,
    d: "M14 500H157L237 345L318 500H461L319 255L461 0H318L237 153L157 0H14L151 251L14 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    glyphName: "y",
    horizAdvX: 500,
    d: "M16 500H148L239 114H262L353 500H485L309 -210H178L233 0H139L16 500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    glyphName: "z",
    horizAdvX: 454,
    d: "M41 380V500H412V380L202 120H412V0H41V120L251 380H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    glyphName: "braceleft",
    horizAdvX: 361,
    d: "M251 576L258 448Q258 385 238 358T146 314Q216 297 237 267T259 172L252 55Q252 21 266 2T323 -20V-134Q212 -130 167 -91T121 38L128 159Q128 232 16 261V365Q128 391 128 459L121 586Q121 681 166 719T325 761V647Q282 643 267 626T251 576Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    glyphName: "bar",
    horizAdvX: 268,
    d: "M67 -210V700H201V-210H67Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    glyphName: "braceright",
    horizAdvX: 361,
    d: "M109 55L102 172Q102 236 123 266T215 314Q144 331 124 358T103 448L110 576Q110 609 95 626T36 647V761Q149 757 194 719T240 586L233 459Q233 391 345 365V261Q233 232 233 159L240 38Q240 -52 195 -91T38 -134V-20Q80 -17 94 2T109 55Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    glyphName: "asciitilde",
    horizAdvX: 560,
    d: "M411 170T383 170T276 192T178 214T132 204T88 184L71 175L61 282Q124 334 184 334Q212 334 288 312T384 290Q421 290 472 318L489 328L497 221Q478 202 445 186Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    glyphName: "uni00A0",
    horizAdvX: 220
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    glyphName: "exclamdown",
    horizAdvX: 264,
    d: "M204 500V339H60V500H204ZM191 250L204 -180H59L73 250H191Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    glyphName: "cent",
    horizAdvX: 560,
    d: "M270 -75V29Q88 42 88 248T270 470V571H380V466L459 453L455 353Q376 356 326 356T250 332T224 250T250 168T339 143L455 147L459 47Q420 37 380 34V-75H270Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    glyphName: "sterling",
    horizAdvX: 560,
    d: "M333 551Q281 551 281 486V433H434V319H281V114H405L474 130L495 18L414 0H75V114H149V319H85V433H149V492Q149 596 189 633T315 671Q382 671 446 653L468 647L464 543Q396 551 333 551Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    glyphName: "currency",
    horizAdvX: 560,
    d: "M325 55T280 55T195 75L122 2L30 94L102 166Q83 207 83 251T102 337L30 410L122 502L194 429Q234 449 279 449T365 429L438 502L530 410L457 337Q477 297 477 252T457 166L530 94L438 2L365 75Q325 55 280 55ZM245 166T280 166T340 191T366 252T341 312T280 338T220 313T194 252T219 192Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    glyphName: "yen",
    horizAdvX: 560,
    d: "M58 291V403H150L5 660H158L281 449L403 660H556L413 403H502V291H351V246H502V134H351V0H213V134H58V246H213V291H58Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    glyphName: "brokenbar",
    horizAdvX: 272,
    d: "M69 700H203V328H69V700ZM69 170H203V-210H69V170Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    glyphName: "section",
    horizAdvX: 517,
    d: "M444 506Q331 522 278 522T206 508T187 457Q187 435 214 424T327 391T444 341T475 243T425 102Q445 83 454 61T463 -7Q463 -104 412 -147T246 -190Q190 -190 91 -172L60 -167L73 -59Q181 -74 234 -74T311 -61T335 -19T310 22T195 56T71 110T37 213Q37 248 57 287T101 347Q57 379 57 455Q57 638 274 638Q338 638 422 620L450 614L444 506ZM189 302Q172 276 172 243T183 198T234 176T321 149Q339 172 339 222Q339 247 323 259T279 279T225 293T189 302Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    glyphName: "dieresis",
    horizAdvX: 268,
    d: "M-30 596V728H98V596H-30ZM186 596V728H314V596H186Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    glyphName: "copyright",
    horizAdvX: 643,
    d: "M203 150T125 232T46 435T124 637T323 718T521 636T597 432T521 231T324 150ZM108 527T108 434T169 276T321 210T474 275T535 433T474 592T322 658T170 593ZM414 287Q386 269 324 269T232 305T202 434T232 563T334 598Q373 598 404 586L414 583L407 497Q372 503 346 503T313 489T305 439Q305 364 340 364L407 369L414 287Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    glyphName: "ordfeminine",
    horizAdvX: 416,
    d: "M351 544V403Q359 397 369 395L367 313Q299 313 276 320T240 346Q198 314 148 314T70 343T42 424Q42 519 169 525L236 528V550Q236 565 192 565L61 558L58 633Q128 659 202 659T313 635T351 544ZM188 402Q206 402 236 418V458L189 455Q157 452 157 428Q157 402 188 402Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    glyphName: "guillemotleft",
    horizAdvX: 601,
    d: "M263 319L154 244L263 158V23L40 194V290L263 454V319ZM546 319L437 244L546 158V23L323 194V290L546 454V319Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    glyphName: "logicalnot",
    horizAdvX: 560,
    d: "M57 358H493V104H373V238H57V358Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    glyphName: "registered",
    horizAdvX: 643,
    d: "M203 150T125 231T46 435T124 637T323 718T520 636T597 432T522 231T325 150ZM108 526T108 434T170 276T322 210T474 275T535 433T474 592T322 658T170 592ZM297 369V276H201V591H337Q389 591 420 566T451 494T443 426T413 386L454 276H354L326 369H297ZM296 519V440H324Q358 440 358 479T323 519H296Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    glyphName: "overscore",
    horizAdvX: 268,
    d: "M-5 597V697H282V597H-5Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    glyphName: "degree",
    horizAdvX: 560,
    d: "M130 475T130 542T171 650T280 692T388 651T430 542T389 434T280 393T172 434ZM205 576T205 542T225 487T280 466T335 487T357 542T336 597T280 619T226 598Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    glyphName: "plusminus",
    horizAdvX: 560,
    d: "M50 270V390H219V498H339V390H510V270H339V170H219V270H50ZM50 139H510V19H50V139Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    glyphName: "twosuperior",
    horizAdvX: 280,
    d: "M252 478H21V568L94 627Q140 664 140 684Q140 699 103 699L27 693L23 792Q96 801 149 801T227 778T252 712T239 646T196 601L158 573H252V478Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    glyphName: "threesuperior",
    horizAdvX: 280,
    d: "M132 801Q253 801 253 712Q253 659 224 642Q259 627 259 572Q259 467 141 467L20 475L26 568Q87 562 118 562T149 578Q149 592 123 592H57V677H121Q141 677 141 691T114 706L30 701L24 792Q92 801 132 801Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    glyphName: "acute",
    horizAdvX: 268,
    d: "M5 651L257 753L297 638L35 564L5 651Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    glyphName: "mu",
    horizAdvX: 560,
    d: "M363 500H497V0H364V28Q292 -12 239 -12Q216 -12 197 -9V-210H63V500H197V211Q198 153 211 131T267 108Q311 108 350 122L363 126V500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    glyphName: "paragraph",
    horizAdvX: 599,
    d: "M397 0V566H335V0H221V286H214Q130 286 79 340T28 482T80 624T216 680H547V566H511V0H397Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    glyphName: "middot",
    horizAdvX: 256,
    d: "M56 167V333H200V167H56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    glyphName: "cedilla",
    horizAdvX: 264,
    d: "M175 -38T204 -56T234 -129T205 -212T123 -241Q79 -241 44 -233L30 -230L34 -152Q65 -153 82 -153Q120 -153 120 -127Q120 -105 82 -105H58V1H111V-37Q175 -38 204 -56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    glyphName: "onesuperior",
    horizAdvX: 280,
    d: "M212 790V478H106V673L59 641L10 715L116 790H212Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    glyphName: "ordmasculine",
    horizAdvX: 420,
    d: "M211 659Q380 659 380 487T211 314Q40 314 40 486T211 659ZM182 419T211 419T249 435T259 488T250 540T211 555T171 540T160 488T171 436Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    glyphName: "guillemotright",
    horizAdvX: 603,
    d: "M447 244L338 319V454L561 290V194L338 23V158L447 244ZM164 244L55 319V454L278 290V194L55 23V158L164 244Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    glyphName: "onequarter",
    horizAdvX: 548,
    d: "M220 790V478H114V673L67 641L18 715L124 790H220ZM29 29L422 661L475 626L82 -7L29 29ZM409 -100V-65H277V23L316 212H434L382 30H409L423 120H514V30H525V-65H514V-100H409Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    glyphName: "onehalf",
    horizAdvX: 542,
    d: "M220 790V478H114V673L67 641L18 715L124 790H220ZM29 29L422 661L475 626L82 -7L29 29ZM512 -100H281V-10L354 49Q400 86 400 106Q400 121 363 121L287 115L283 214Q356 223 409 223T487 200T512 134T499 68T456 23L418 -5H512V-100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    glyphName: "threequarters",
    horizAdvX: 561,
    d: "M148 801Q269 801 269 712Q269 659 240 642Q275 627 275 572Q275 467 157 467L36 475L42 568Q103 562 134 562T165 578Q165 592 139 592H73V677H137Q157 677 157 691T130 706L46 701L40 792Q108 801 148 801ZM43 29L436 661L489 626L96 -7L43 29ZM423 -100V-65H291V23L330 212H448L396 30H423L437 120H528V30H539V-65H528V-100H423Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    glyphName: "questiondown",
    horizAdvX: 433,
    d: "M126 -192T78 -153T29 -36T44 77T110 150T173 208T186 252V283H293Q324 249 324 192Q324 156 261 105T183 35T168 -13Q168 -72 253 -72Q313 -72 376 -60L397 -56L404 -157Q318 -192 222 -192ZM315 500V339H171V500H315Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    glyphName: "Agrave",
    horizAdvX: 602,
    d: "M17 0L170 680H432L585 0H447L420 123H182L155 0H17ZM277 566L208 243H394L325 566H277ZM183 945L435 839L402 746L142 825L183 945Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    glyphName: "Aacute",
    horizAdvX: 602,
    d: "M17 0L170 680H432L585 0H447L420 123H182L155 0H17ZM277 566L208 243H394L325 566H277ZM162 839L414 945L455 825L195 746L162 839Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    glyphName: "Acircumflex",
    horizAdvX: 602,
    d: "M17 0L170 680H432L585 0H447L420 123H182L155 0H17ZM277 566L208 243H394L325 566H277ZM107 765L241 914H358L492 765H350L301 821L249 765H107Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    glyphName: "Atilde",
    horizAdvX: 602,
    d: "M17 0L170 680H432L585 0H447L420 123H182L155 0H17ZM277 566L208 243H394L325 566H277ZM403 758T377 758T288 781T211 804Q186 804 144 772L130 762L101 858Q121 882 152 902T213 922T304 899T376 876Q399 876 442 908L457 918L486 821Q465 797 434 778Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    glyphName: "Adieresis",
    horizAdvX: 602,
    d: "M17 0L170 680H432L585 0H447L420 123H182L155 0H17ZM277 566L208 243H394L325 566H277ZM129 764V896H257V764H129ZM343 764V896H471V764H343Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    glyphName: "Aring",
    horizAdvX: 602,
    d: "M451 721Q451 690 436 662L585 0H447L420 123H182L155 0H17L166 662Q151 688 151 721Q151 780 194 813T301 847T408 814T451 721ZM277 566L208 243H394L325 566H277ZM274 762T258 751T242 722T256 692T295 680H301Q328 680 344 691T360 721T344 751T301 762Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    glyphName: "AE",
    horizAdvX: 871,
    d: "M392 0V116H179L150 0H12L196 690H830V558H528V415H770V284H528V132H830V0H392ZM293 558L213 249H392L393 558H293Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    glyphName: "Ccedilla",
    horizAdvX: 543,
    d: "M379 -38T408 -56T438 -129T409 -212T327 -241Q284 -241 248 -233L234 -230L238 -152Q269 -153 286 -153Q324 -153 324 -127Q324 -105 286 -105H262V-10Q138 2 93 84T47 351T102 614T307 692Q393 692 506 665L502 555Q403 570 338 570T244 553T203 486T189 319T216 156T326 110T502 124L505 11Q411 -10 315 -12V-37Q379 -38 408 -56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    glyphName: "Egrave",
    horizAdvX: 554,
    d: "M74 0V680H514V560H212V401H454V283H212V120H514V0H74ZM180 945L432 839L399 746L139 825L180 945Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    glyphName: "Eacute",
    horizAdvX: 554,
    d: "M74 0V680H514V560H212V401H454V283H212V120H514V0H74ZM154 839L406 945L447 825L187 746L154 839Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    glyphName: "Ecircumflex",
    horizAdvX: 554,
    d: "M74 0V680H514V560H212V401H454V283H212V120H514V0H74ZM105 765L239 914H356L490 765H348L299 821L247 765H105Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    glyphName: "Edieresis",
    horizAdvX: 554,
    d: "M74 0V680H514V560H212V401H454V283H212V120H514V0H74ZM123 764V896H251V764H123ZM337 764V896H465V764H337Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    glyphName: "Igrave",
    horizAdvX: 286,
    d: "M74 0V680H212V0H74ZM17 945L269 839L236 746L-24 825L17 945Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    glyphName: "Iacute",
    horizAdvX: 286,
    d: "M74 0V680H212V0H74ZM7 839L259 945L300 825L40 746L7 839Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    glyphName: "Icircumflex",
    horizAdvX: 286,
    d: "M74 0V680H212V0H74ZM-50 765L84 914H201L335 765H193L144 821L92 765H-50Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    glyphName: "Idieresis",
    horizAdvX: 286,
    d: "M74 0V680H212V0H74ZM-28 764V896H100V764H-28ZM186 764V896H314V764H186Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    glyphName: "Eth",
    horizAdvX: 642,
    d: "M25 277V409H79V690H306Q394 690 451 671T539 609T583 507T595 356T584 202T543 93T454 22T306 0H79V277H25ZM453 354Q453 397 452 422T445 472T430 511T404 538Q373 559 306 559H215V409H345V277H215V131H306Q381 131 416 169Q453 210 453 354Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    glyphName: "Ntilde",
    horizAdvX: 693,
    d: "M74 0V680H307L471 120H481V680H619V0H392L222 560H212V0H74ZM451 758T425 758T336 781T259 804Q234 804 192 772L178 762L149 858Q169 882 200 902T261 922T352 899T424 876Q447 876 490 908L505 918L534 821Q513 797 482 778Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    glyphName: "Ograve",
    horizAdvX: 652,
    d: "M245 108T326 108T436 160T466 336T436 516T326 572T216 516T186 337T215 161ZM481 -12T326 -12T108 72T44 337T107 604T326 692T544 605T608 337T545 73ZM204 945L456 839L423 746L163 825L204 945Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    glyphName: "Oacute",
    horizAdvX: 652,
    d: "M245 108T326 108T436 160T466 336T436 516T326 572T216 516T186 337T215 161ZM481 -12T326 -12T108 72T44 337T107 604T326 692T544 605T608 337T545 73ZM167 839L419 945L460 825L200 746L167 839Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    glyphName: "Ocircumflex",
    horizAdvX: 652,
    d: "M245 108T326 108T436 160T466 336T436 516T326 572T216 516T186 337T215 161ZM481 -12T326 -12T108 72T44 337T107 604T326 692T544 605T608 337T545 73ZM135 765L269 914H386L520 765H378L329 821L277 765H135Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    glyphName: "Otilde",
    horizAdvX: 652,
    d: "M245 108T326 108T436 160T466 336T436 516T326 572T216 516T186 337T215 161ZM481 -12T326 -12T108 72T44 337T107 604T326 692T544 605T608 337T545 73ZM435 758T409 758T320 781T243 804Q218 804 176 772L162 762L133 858Q153 882 184 902T245 922T336 899T408 876Q431 876 474 908L489 918L518 821Q497 797 466 778Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    glyphName: "Odieresis",
    horizAdvX: 652,
    d: "M245 108T326 108T436 160T466 336T436 516T326 572T216 516T186 337T215 161ZM481 -12T326 -12T108 72T44 337T107 604T326 692T544 605T608 337T545 73ZM155 764V896H283V764H155ZM369 764V896H497V764H369Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    glyphName: "multiply",
    horizAdvX: 560,
    d: "M142 473L280 332L420 475L504 390L361 250L504 111L419 26L280 168L141 27L56 111L198 250L57 388L142 473Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    glyphName: "Oslash",
    horizAdvX: 652,
    d: "M326 -12Q277 -12 230 -2L172 -127L74 -78L132 46Q44 124 44 336Q44 517 107 604T326 692Q384 692 427 680L488 810L588 767L523 627Q608 545 608 336Q608 157 545 73T326 -12ZM246 572T216 516T186 352T201 194L374 565Q350 572 326 572Q246 572 216 516ZM326 108Q407 108 436 160T466 319T452 475L283 112Q300 108 326 108Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    glyphName: "Ugrave",
    horizAdvX: 654,
    d: "M206 227Q206 108 327 108T448 227V680H586V230Q586 105 522 47T327 -12T133 46T68 230V680H206V227ZM216 945L468 839L435 746L175 825L216 945Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    glyphName: "Uacute",
    horizAdvX: 654,
    d: "M206 227Q206 108 327 108T448 227V680H586V230Q586 105 522 47T327 -12T133 46T68 230V680H206V227ZM175 839L427 945L468 825L208 746L175 839Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    glyphName: "Ucircumflex",
    horizAdvX: 654,
    d: "M206 227Q206 108 327 108T448 227V680H586V230Q586 105 522 47T327 -12T133 46T68 230V680H206V227ZM135 765L269 914H386L520 765H378L329 821L277 765H135Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    glyphName: "Udieresis",
    horizAdvX: 654,
    d: "M206 227Q206 108 327 108T448 227V680H586V230Q586 105 522 47T327 -12T133 46T68 230V680H206V227ZM156 764V896H284V764H156ZM370 764V896H498V764H370Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    glyphName: "Yacute",
    horizAdvX: 557,
    d: "M348 0H210V275L0 680H153L278 409L403 680H556L348 275V0ZM133 839L385 945L426 825L166 746L133 839Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    glyphName: "Thorn",
    horizAdvX: 596,
    d: "M323 233Q374 233 401 264T428 353Q428 460 323 460H212V233H323ZM324 99H212V0H74V690H212V592H324Q568 592 568 353Q568 232 506 166T324 99Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    glyphName: "germandbls",
    horizAdvX: 611,
    d: "M196 0H62V522Q62 624 115 668T289 712T466 675T523 555Q523 501 502 476T436 432T381 403T370 380T386 354T468 312T561 252T588 164Q588 63 543 26T386 -12Q332 -12 256 6L232 11L236 118Q333 106 370 106Q450 106 450 144Q450 167 435 179T354 219T260 280T232 365T250 444T312 490T370 519T385 551T365 583T292 594T217 577T196 519V0Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    glyphName: "agrave",
    horizAdvX: 511,
    d: "M445 344V136Q447 112 453 103T478 89L474 -12Q423 -12 393 -5T331 23Q259 -12 184 -12Q29 -12 29 152Q29 232 72 265T204 305L311 313V344Q311 375 297 386T252 398L64 390L60 483Q167 512 263 512T402 472T445 344ZM220 212Q164 207 164 152T213 97Q251 97 296 109L311 113V220L220 212ZM143 753L395 651L365 564L103 638L143 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    glyphName: "aacute",
    horizAdvX: 511,
    d: "M445 344V136Q447 112 453 103T478 89L474 -12Q423 -12 393 -5T331 23Q259 -12 184 -12Q29 -12 29 152Q29 232 72 265T204 305L311 313V344Q311 375 297 386T252 398L64 390L60 483Q167 512 263 512T402 472T445 344ZM220 212Q164 207 164 152T213 97Q251 97 296 109L311 113V220L220 212ZM96 651L348 753L388 638L126 564L96 651Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    glyphName: "acircumflex",
    horizAdvX: 511,
    d: "M445 344V136Q447 112 453 103T478 89L474 -12Q423 -12 393 -5T331 23Q259 -12 184 -12Q29 -12 29 152Q29 232 72 265T204 305L311 313V344Q311 375 297 386T252 398L64 390L60 483Q167 512 263 512T402 472T445 344ZM220 212Q164 207 164 152T213 97Q251 97 296 109L311 113V220L220 212ZM83 580L209 731H293L421 580H298L252 647L206 580H83Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    glyphName: "atilde",
    horizAdvX: 511,
    d: "M445 344V136Q447 112 453 103T478 89L474 -12Q423 -12 393 -5T331 23Q259 -12 184 -12Q29 -12 29 152Q29 232 72 265T204 305L311 313V344Q311 375 297 386T252 398L64 390L60 483Q167 512 263 512T402 472T445 344ZM220 212Q164 207 164 152T213 97Q251 97 296 109L311 113V220L220 212ZM368 619T340 602T290 585T221 603T162 621Q133 621 96 598L83 590L54 665Q74 688 104 706T157 725T226 707T285 689Q309 689 351 714L365 723L394 647Q388 640 378 630Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    glyphName: "adieresis",
    horizAdvX: 511,
    d: "M445 344V136Q447 112 453 103T478 89L474 -12Q423 -12 393 -5T331 23Q259 -12 184 -12Q29 -12 29 152Q29 232 72 265T204 305L311 313V344Q311 375 297 386T252 398L64 390L60 483Q167 512 263 512T402 472T445 344ZM220 212Q164 207 164 152T213 97Q251 97 296 109L311 113V220L220 212ZM65 596V728H193V596H65ZM281 596V728H409V596H281Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    glyphName: "aring",
    horizAdvX: 511,
    d: "M445 344V136Q447 112 453 103T478 89L474 -12Q423 -12 393 -5T331 23Q259 -12 184 -12Q29 -12 29 152Q29 232 72 265T204 305L311 313V344Q311 375 297 386T252 398L64 390L60 483Q167 512 263 512T402 472T445 344ZM220 212Q164 207 164 152T213 97Q251 97 296 109L311 113V220L220 212ZM215 521T182 554T148 637T181 721T264 755T348 721T382 638T348 555T265 521ZM220 658T220 638T233 605T266 592T298 605T311 638T299 670T266 683T233 671Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    glyphName: "ae",
    horizAdvX: 784,
    d: "M446 149T469 130T537 111Q605 111 703 118L731 120L733 16Q618 -12 521 -12T372 36L349 25Q265 -12 185 -12T67 31T29 153T72 266T203 306L311 313V338Q311 358 297 370T256 383Q184 383 99 375L67 372L63 489Q196 511 275 511T398 474Q450 511 531 511Q749 511 749 286L739 192H445Q446 149 469 130ZM311 118L310 211L220 207Q164 204 164 156Q164 103 205 103Q245 103 294 114L311 118ZM445 295H617Q617 348 598 370T531 392T464 369T445 295Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    glyphName: "ccedilla",
    horizAdvX: 446,
    d: "M319 -38T348 -56T378 -129T349 -212T267 -241Q224 -241 188 -233L174 -230L178 -152Q209 -153 226 -153Q264 -153 264 -127Q264 -105 226 -105H202V-9Q115 2 77 65T38 258T88 450T249 512Q301 512 382 496L409 490L405 384Q326 392 288 392Q219 392 197 363T174 251T196 139T289 108L405 116L409 9Q312 -10 255 -12V-37Q319 -38 348 -56Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    glyphName: "egrave",
    horizAdvX: 510,
    d: "M173 147T196 127T264 106Q357 106 430 112L458 115L460 16Q345 -12 252 -12Q139 -12 88 48T37 243Q37 512 258 512Q476 512 476 286L466 193H172Q173 147 196 127ZM344 295Q344 355 325 378T259 402T192 378T171 295H344ZM150 753L402 651L372 564L110 638L150 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    glyphName: "eacute",
    horizAdvX: 510,
    d: "M173 147T196 127T264 106Q357 106 430 112L458 115L460 16Q345 -12 252 -12Q139 -12 88 48T37 243Q37 512 258 512Q476 512 476 286L466 193H172Q173 147 196 127ZM344 295Q344 355 325 378T259 402T192 378T171 295H344ZM105 651L357 753L397 638L135 564L105 651Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    glyphName: "ecircumflex",
    horizAdvX: 510,
    d: "M173 147T196 127T264 106Q357 106 430 112L458 115L460 16Q345 -12 252 -12Q139 -12 88 48T37 243Q37 512 258 512Q476 512 476 286L466 193H172Q173 147 196 127ZM344 295Q344 355 325 378T259 402T192 378T171 295H344ZM89 580L215 731H299L427 580H304L258 647L212 580H89Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    glyphName: "edieresis",
    horizAdvX: 510,
    d: "M173 147T196 127T264 106Q357 106 430 112L458 115L460 16Q345 -12 252 -12Q139 -12 88 48T37 243Q37 512 258 512Q476 512 476 286L466 193H172Q173 147 196 127ZM344 295Q344 355 325 378T259 402T192 378T171 295H344ZM84 596V728H212V596H84ZM300 596V728H428V596H300Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    glyphName: "igrave",
    horizAdvX: 258,
    d: "M62 0V500H196V0H62ZM-19 753L233 651L203 564L-59 638L-19 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    glyphName: "iacute",
    horizAdvX: 258,
    d: "M31 651L283 753L323 638L61 564L31 651ZM62 500H196V0H62V500Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    glyphName: "icircumflex",
    horizAdvX: 258,
    d: "M62 500H196V0H62V500ZM-45 580L81 731H165L293 580H170L124 647L78 580H-45Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    glyphName: "idieresis",
    horizAdvX: 258,
    d: "M62 500H196V0H62V500ZM-48 596V728H80V596H-48ZM168 596V728H296V596H168Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    glyphName: "eth",
    horizAdvX: 567,
    d: "M405 625Q528 537 528 351T468 78T273 -9Q38 -9 38 216Q38 320 92 379T256 438Q318 438 369 420L386 414Q381 461 361 494T297 553L168 467L114 543L190 594Q144 606 82 618L100 712Q221 703 309 673L405 737L459 661L405 625ZM264 320Q223 320 202 290T180 216Q180 111 273 111Q329 111 357 155T386 298Q336 320 264 320Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    glyphName: "ntilde",
    horizAdvX: 553,
    d: "M62 0V500H195V472L214 482Q232 492 263 502T320 512Q420 512 458 453T496 271Q496 271 496 0H362V267Q362 331 347 361T286 392T196 374V0H62ZM425 619T397 602T347 585T278 603T218 621Q190 621 153 598L140 590L111 665Q131 688 161 706T214 725T283 707T342 689Q366 689 408 714L422 723L451 647Q445 640 435 630Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    glyphName: "ograve",
    horizAdvX: 532,
    d: "M142 512T266 512T443 444T496 251Q496 -12 266 -12T36 251Q36 375 89 443ZM213 102T266 102T339 138T360 251T340 363T266 398T193 363T172 251T192 138ZM163 753L415 651L385 564L123 638L163 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    glyphName: "oacute",
    horizAdvX: 532,
    d: "M142 512T266 512T443 444T496 251Q496 -12 266 -12T36 251Q36 375 89 443ZM213 102T266 102T339 138T360 251T340 363T266 398T193 363T172 251T192 138ZM116 651L368 753L408 638L146 564L116 651Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    glyphName: "ocircumflex",
    horizAdvX: 532,
    d: "M142 512T266 512T443 444T496 251Q496 -12 266 -12T36 251Q36 375 89 443ZM213 102T266 102T339 138T360 251T340 363T266 398T193 363T172 251T192 138ZM91 580L217 731H301L429 580H306L260 647L214 580H91Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    glyphName: "otilde",
    horizAdvX: 532,
    d: "M142 512T266 512T443 444T496 251Q496 -12 266 -12T36 251Q36 375 89 443ZM213 102T266 102T339 138T360 251T340 363T266 398T193 363T172 251T192 138ZM405 619T377 602T327 585T258 603T198 621Q170 621 133 598L120 590L91 665Q111 688 141 706T194 725T263 707T322 689Q346 689 388 714L402 723L431 647Q425 640 415 630Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    glyphName: "odieresis",
    horizAdvX: 532,
    d: "M142 512T266 512T443 444T496 251Q496 -12 266 -12T36 251Q36 375 89 443ZM213 102T266 102T339 138T360 251T340 363T266 398T193 363T172 251T192 138ZM93 596V728H221V596H93ZM309 596V728H437V596H309Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    glyphName: "divide",
    horizAdvX: 560,
    d: "M213 352V484H345V352H213ZM50 191V311H510V191H50ZM213 17V149H345V17H213Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    glyphName: "oslash",
    horizAdvX: 532,
    d: "M266 512Q294 512 322 507L362 607L443 577L402 479Q496 420 496 251Q496 -12 266 -12Q232 -12 203 -6L162 -108L82 -78L125 25Q36 85 36 251Q36 375 89 443T266 512ZM266 102Q319 102 339 138T360 245T346 350L246 103Q252 102 266 102ZM279 397L266 398Q213 398 193 363T172 258T184 156L279 397Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    glyphName: "ugrave",
    horizAdvX: 553,
    d: "M357 500H491V0H358V28Q286 -12 233 -12Q129 -12 93 45T57 238V500H191V236Q191 162 203 135T261 108Q305 108 344 122L357 126V500ZM138 753L390 651L360 564L98 638L138 753Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    glyphName: "uacute",
    horizAdvX: 553,
    d: "M491 500V0H358V28L338 18Q319 8 288 -2T233 -12Q129 -12 93 45T57 238Q57 238 57 500H191V236Q191 162 203 135T263 108T357 126V500H491ZM130 651L382 753L422 638L160 564L130 651Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    glyphName: "ucircumflex",
    horizAdvX: 553,
    d: "M491 500V0H358V28L338 18Q319 8 288 -2T233 -12Q129 -12 93 45T57 238Q57 238 57 500H191V236Q191 162 203 135T263 108T357 126V500H491ZM82 580L208 731H292L420 580H297L251 647L205 580H82Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    glyphName: "udieresis",
    horizAdvX: 553,
    d: "M491 500V0H358V28L338 18Q319 8 288 -2T233 -12Q129 -12 93 45T57 238Q57 238 57 500H191V236Q191 162 203 135T263 108T357 126V500H491ZM106 596V728H234V596H106ZM322 596V728H450V596H322Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    glyphName: "yacute",
    horizAdvX: 500,
    d: "M16 500H148L239 114H262L353 500H485L309 -210H178L233 0H139L16 500ZM122 651L374 753L414 638L152 564L122 651Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    glyphName: "thorn",
    horizAdvX: 544,
    d: "M269 104Q327 104 348 138T370 255Q370 392 286 392Q246 392 210 382L196 379V110Q241 104 269 104ZM304 512Q409 512 457 455T506 249T453 45T279 -12Q246 -12 208 -6L196 -4V-210H62V700H196V485Q260 512 304 512Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    glyphName: "ydieresis",
    horizAdvX: 500,
    d: "M16 500H148L239 114H262L353 500H485L309 -210H178L233 0H139L16 500ZM79 596V728H207V596H79ZM295 596V728H423V596H295Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    glyphName: "endash",
    horizAdvX: 614,
    d: "M57 323H557V209H57V323Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    glyphName: "emdash",
    horizAdvX: 1114,
    d: "M57 323H1057V209H57V323Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    glyphName: "quoteleft",
    horizAdvX: 259,
    d: "M223 679L175 432H35L120 679H223Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    glyphName: "quoteright",
    horizAdvX: 254,
    d: "M41 433L88 680H229L144 433H41Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    glyphName: "quotesinglbase",
    horizAdvX: 256,
    d: "M23 -117L70 130H211L126 -117H23Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    glyphName: "quotedblleft",
    horizAdvX: 443,
    d: "M407 679L359 432H219L304 679H407ZM223 679L175 432H35L120 679H223Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    glyphName: "quotedblright",
    horizAdvX: 439,
    d: "M41 434L88 681H229L143 434H41ZM225 434L272 681H413L328 434H225Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    glyphName: "quotedblbase",
    horizAdvX: 421,
    d: "M181 117L133 -130H-7L78 117H181ZM371 117L323 -130H183L268 117H371Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    glyphName: "bullet",
    horizAdvX: 450,
    d: "M100 100V380H350V100H100Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    glyphName: "guilsinglleft",
    horizAdvX: 318,
    d: "M263 319L154 244L263 158V23L40 194V290L263 454V319Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    glyphName: "guilsinglright",
    horizAdvX: 318,
    d: "M163 254L54 329V464L277 300V204L54 33V168L163 254Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitilliumWebV8Latin700);
export default __webpack_public_path__ + "static/media/titillium-web-v8-latin-700.6197aacb0b05def66f035004f7a9700d.svg";
export { ForwardRef as ReactComponent };